import { containerConfiguration } from '@mews/framework';

import baseConfiguration from './baseConfiguration';
import {
    AccountingCategoriesComponent,
    AccountingConfigurationComponent,
    BillComponent,
    CalendarEventComponent,
    CashierAssignmentsComponent,
    CashiersComponent,
    ChainComponent,
    ChannelManagerAgeCategoryComponent,
    CityComponent,
    CommandComponent,
    CompanionshipComponent,
    CompanyComponent,
    CreditCardComponent,
    CreditLimitsComponent,
    CustomerComponent,
    DepartmentsComponent,
    EnterpriseProfileComponent,
    ExchangeRateComponent,
    IdentityDocumentsComponent,
    ImportComponent,
    LocationsComponent,
    MessageComponent,
    MessageThreadComponent,
    NotificationComponent,
    OrderItemComponent,
    PassportScannerComponent,
    PaymentCardsComponent,
    PlatformComponent,
    PowerBiComponent,
    PricingComponent,
    ProductsComponent,
    ProductServiceOrdersComponent,
    ReservationComponent,
    ReservationGroupComponent,
    ResourceBlockComponent,
    ResourceComponent,
    ServiceComponent,
    SourcesComponent,
    SubscriptionsComponent,
    TaskComponent,
    TravelAgencyComponent,
} from './components/api';

import ApiComponent from './components/apiComponent';
import GeneralApiComponent from './components/generalApiComponent';

export default function commanderContainerConfiguration({ api, generalApi, ...other }: $TSFixMe) {
    return containerConfiguration()
        .extend(baseConfiguration({ ...other }))

        .register(ApiComponent, [], api)
        .register(GeneralApiComponent, [], generalApi)

        .register(AccountingCategoriesComponent, [ApiComponent])
        .register(AccountingConfigurationComponent, [ApiComponent])
        .register(BillComponent, [ApiComponent])
        .register(CalendarEventComponent, [ApiComponent])
        .register(CashierAssignmentsComponent, [ApiComponent])
        .register(CashiersComponent, [ApiComponent])
        .register(ChainComponent, [ApiComponent])
        .register(ChannelManagerAgeCategoryComponent, [ApiComponent])
        .register(CityComponent, [GeneralApiComponent])
        .register(CommandComponent, [ApiComponent])
        .register(CompanionshipComponent, [ApiComponent])
        .register(CompanyComponent, [ApiComponent])
        .register(CreditCardComponent, [ApiComponent])
        .register(CreditLimitsComponent, [ApiComponent])
        .register(CustomerComponent, [ApiComponent])
        .register(DepartmentsComponent, [ApiComponent])
        .register(EnterpriseProfileComponent, [ApiComponent])
        .register(ExchangeRateComponent, [ApiComponent])
        .register(IdentityDocumentsComponent, [ApiComponent])
        .register(ImportComponent, [ApiComponent])
        .register(LocationsComponent, [GeneralApiComponent])
        .register(MessageComponent, [ApiComponent])
        .register(MessageThreadComponent, [ApiComponent])
        .register(NotificationComponent, [ApiComponent])
        .register(OrderItemComponent, [ApiComponent])
        .register(PassportScannerComponent, [ApiComponent])
        .register(PaymentCardsComponent, [ApiComponent])
        .register(PlatformComponent, [GeneralApiComponent])
        .register(PowerBiComponent, [ApiComponent])
        .register(PricingComponent, [ApiComponent])
        .register(ProductsComponent, [ApiComponent])
        .register(ProductServiceOrdersComponent, [ApiComponent])
        .register(ReservationComponent, [ApiComponent])
        .register(ReservationGroupComponent, [ApiComponent])
        .register(ResourceBlockComponent, [ApiComponent])
        .register(ResourceComponent, [ApiComponent])
        .register(ServiceComponent, [ApiComponent])
        .register(SourcesComponent, [ApiComponent])
        .register(SubscriptionsComponent, [GeneralApiComponent])
        .register(TaskComponent, [ApiComponent])
        .register(TravelAgencyComponent, [ApiComponent]);
}

declare global {
    interface CommanderContainer {
        /** @deprecated use repositories */
        accountingCategoriesComponent: ReturnType<typeof AccountingCategoriesComponent>;
        /** @deprecated use repositories */
        accountingConfigurationComponent: ReturnType<typeof AccountingConfigurationComponent>;
        apiComponent: ReturnType<typeof ApiComponent>;
        /** @deprecated use repositories */
        billComponent: ReturnType<typeof BillComponent>;
        /** @deprecated use repositories */
        calendarEventComponent: ReturnType<typeof CalendarEventComponent>;
        /** @deprecated use repositories */
        cashierAssignmentsComponent: ReturnType<typeof CashierAssignmentsComponent>;
        /** @deprecated use repositories */
        cashiersComponent: ReturnType<typeof CashiersComponent>;
        /** @deprecated use repositories */
        chainComponent: ReturnType<typeof ChainComponent>;
        /** @deprecated use repositories */
        channelManagerAgeCategoryComponent: ReturnType<typeof ChannelManagerAgeCategoryComponent>;
        /** @deprecated use repositories */
        cityComponent: ReturnType<typeof CityComponent>;
        /** @deprecated use repositories */
        commandComponent: ReturnType<typeof CommandComponent>;
        /** @deprecated use repositories */
        companionshipComponent: ReturnType<typeof CompanionshipComponent>;
        /** @deprecated use repositories */
        companyComponent: ReturnType<typeof CompanyComponent>;
        /** @deprecated use repositories */
        creditCardComponent: ReturnType<typeof CreditCardComponent>;
        /** @deprecated use repositories */
        creditLimitsComponent: ReturnType<typeof CreditLimitsComponent>;
        /** @deprecated use repositories */
        customerComponent: ReturnType<typeof CustomerComponent>;
        /** @deprecated use repositories */
        departmentsComponent: ReturnType<typeof DepartmentsComponent>;
        /** @deprecated use repositories */
        enterpriseProfileComponent: ReturnType<typeof EnterpriseProfileComponent>;
        /** @deprecated use repositories */
        exchangeRateComponent: ReturnType<typeof ExchangeRateComponent>;
        generalApiComponent: ReturnType<typeof GeneralApiComponent>;
        /** @deprecated use repositories */
        identityDocumentsComponent: ReturnType<typeof IdentityDocumentsComponent>;
        /** @deprecated use repositories */
        importComponent: ReturnType<typeof ImportComponent>;
        /** @deprecated use repositories */
        locationsComponent: ReturnType<typeof LocationsComponent>;
        /** @deprecated use repositories */
        messageComponent: ReturnType<typeof MessageComponent>;
        /** @deprecated use repositories */
        messageThreadComponent: ReturnType<typeof MessageThreadComponent>;
        /** @deprecated use repositories */
        notificationComponent: ReturnType<typeof NotificationComponent>;
        /** @deprecated use repositories */
        orderItemComponent: ReturnType<typeof OrderItemComponent>;
        /** @deprecated use repositories */
        passportScannerComponent: ReturnType<typeof PassportScannerComponent>;
        /** @deprecated use repositories */
        paymentCardsComponent: ReturnType<typeof PaymentCardsComponent>;
        /** @deprecated use repositories */
        platformComponent: ReturnType<typeof PlatformComponent>;
        /** @deprecated use repositories */
        powerBiComponent: ReturnType<typeof PowerBiComponent>;
        /** @deprecated use repositories */
        pricingComponent: ReturnType<typeof PricingComponent>;
        /** @deprecated use repositories */
        productsComponent: ReturnType<typeof ProductsComponent>;
        /** @deprecated use repositories */
        productServiceOrdersComponent: ReturnType<typeof ProductServiceOrdersComponent>;
        /** @deprecated use repositories */
        reservationComponent: ReturnType<typeof ReservationComponent>;
        /** @deprecated use repositories */
        reservationGroupComponent: ReturnType<typeof ReservationGroupComponent>;
        /** @deprecated use repositories */
        resourceBlockComponent: ReturnType<typeof ResourceBlockComponent>;
        /** @deprecated use repositories */
        resourceComponent: ReturnType<typeof ResourceComponent>;
        /** @deprecated use repositories */
        serviceComponent: ReturnType<typeof ServiceComponent>;
        /** @deprecated use repositories */
        sourcesComponent: ReturnType<typeof SourcesComponent>;
        /** @deprecated use repositories */
        subscriptionsComponent: ReturnType<typeof SubscriptionsComponent>;
        /** @deprecated use repositories */
        taskComponent: ReturnType<typeof TaskComponent>;
        /** @deprecated use repositories */
        travelAgencyComponent: ReturnType<typeof TravelAgencyComponent>;
    }
}
